import type { TextField } from "@payloadcms/plugin-form-builder/types";
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from "react-hook-form";

import { Input } from "@onclicks/sharedcomponents/ui/Input";
import React from "react";

import { FieldError } from "./FieldError";
import { FieldLabel } from "./FieldLabel";
import { fieldClassName } from "./fieldStyles";

export const Number: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>;
    register: UseFormRegister<FieldValues>;
  }
> = ({ name, defaultValue, errors, label, register, required }) => {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel htmlFor={name} label={label} required={required} />
      <Input
        defaultValue={defaultValue}
        id={name}
        type="number"
        aria-invalid={!!errors[name]}
        className={fieldClassName}
        {...register(name, { required })}
      />
      {errors[name] && <FieldError name={name} />}
    </div>
  );
};
